import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { useSelector } from "react-redux";
import { useCollapsibleSectionsContext } from "~/components/AssetModalV2/InfoPanel/CollapsibleSectionsContextProvider";
import { CollapsibleSection } from "~/components/AssetModalV2/InfoPanel/components/CollapsibleSection";
import { FileInfo } from "~/components/AssetModalV2/InfoPanel/DescriptionAndTags/FileInfo";
import { DESCRIPTION_AND_TAGS_SECTION } from "~/components/AssetModalV2/InfoPanel/DescriptionAndTags/PrivateDescriptionAndTagsCollapsibleSection";
import { SmartTagKeywords } from "~/components/AssetModalV2/InfoPanel/DescriptionAndTags/SmartTagKeywords";
import { centralizedClipKeywordsSelector, centralizedClipSummarySelector } from "~/store/centralizedClip/selectors";
export const PublicDescriptionAndTagsCollapsibleSection = /*#__PURE__*/ memo(()=>{
    const summary = useSelector(centralizedClipSummarySelector);
    const keywords = useSelector(centralizedClipKeywordsSelector);
    const { expandedSections, toggleSection } = useCollapsibleSectionsContext();
    const isExpanded = expandedSections["descriptionAndTags"];
    const onOpenChange = useCallback(()=>{
        toggleSection("descriptionAndTags");
    }, [
        toggleSection
    ]);
    return /*#__PURE__*/ _jsx(CollapsibleSection, {
        title: "Description and Tags",
        isExpanded: isExpanded,
        onOpenChange: onOpenChange,
        "data-testid": DESCRIPTION_AND_TAGS_SECTION,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex flex-col [&>*+*]:mt-4",
            children: [
                !!summary && /*#__PURE__*/ _jsx("div", {
                    className: "text-12 text-grey-11",
                    "data-testid": "INFO_PANEL_SUMMARY_TEXT",
                    children: summary
                }),
                /*#__PURE__*/ _jsx(SmartTagKeywords, {}),
                (!!summary || !!(keywords === null || keywords === void 0 ? void 0 : keywords.length)) && /*#__PURE__*/ _jsx("div", {
                    className: "text-12 text-grey-9",
                    children: "Summary and smart tags are AI generated"
                }),
                /*#__PURE__*/ _jsx(FileInfo, {})
            ]
        })
    });
});
PublicDescriptionAndTagsCollapsibleSection.displayName = "PublicDescriptionAndTagsCollapsibleSection";
